import { KeyboardEvent } from 'react';
import { SearchInputForm } from 'src/components/common/form/search/SearchInputForm';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { useTQC5010_R01Store } from './Store_TQC5010_R01';

interface Props {
	/** 검색 입력란에서 Enter 키 입력 시 조회를 실행한다. */
	onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

/** 검사항목 조회 조건(검사항목그룹, 검사기준명) 입력 영역 */
export const SearchSection_TQC5010_R01 = ({ onEnterKeyDown }: Props) => {
	const { TQC5010_R01Filter, setTQC5010_R01Filter } = useTQC5010_R01Store();
	const { itemGroupList } = useCommonCodeStore();

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="품목그룹"
				value={TQC5010_R01Filter.inspItemGroup}
				optionList={itemGroupList}
				onChangeItem={(selectedItem) =>
					setTQC5010_R01Filter({ inspItemGroup: selectedItem?.minorCd || '' })
				}
			/>
			<SearchInputForm
				label="항목명"
				value={TQC5010_R01Filter.inspItemNm}
				onChange={(e) => setTQC5010_R01Filter({ inspItemNm: e.target.value })}
				onKeyDown={(e) => { if (e.key === 'Enter') onEnterKeyDown(e); }}
				initValue={() => setTQC5010_R01Filter({ inspItemNm: '' })}
			/>
		</SearchSectionForm>
	);
};
